import {RouteConfig} from 'vue-router';
import { QuizCategory } from '@/models/Quiz';
import { Routes } from '@/router/Routes';

const StatementRoutes: RouteConfig = {
  path: 'statements_test',
  component: () => import('../views/StatementsNavigation.vue'),
  redirect: '/statements_test/start',
  children: [
    {
      path: 'start',
      name: Routes.STATEMENTS_TEST.START_STATEMENTS_TEST,
      component: () => import('../views/StatementsQuiz.vue'),
    },
    {
      path: 'unicredit',
      name: Routes.STATEMENTS_TEST.UNI_CREDIT_STATEMENT,
      component: () => import('../views/OneOffStatement.vue'),
      // Widok jest generyczny — kategorię (i przez nią treść oraz endpointy) bierze z meta.
      meta: {
        quizCategory: QuizCategory.UNI_CREDIT,
      },
    },
  ],
}

export default StatementRoutes;
